// RxJS
import { debounceTime } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectContactRelationshipsInStore,
  selectContactRelationshipsPageLoading,
  selectCRShowInitWaitingMessage,
} from '../_selectors/contact-relationship.selectors';
export class ContactRelationshipsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.store
      .pipe(select(selectContactRelationshipsInStore), debounceTime(600))
      .subscribe((response: QueryResultsModel) => {
        this.entitySubject.next(response.items);
        this.paginatorTotalSubject.next(response.totalCount);
        this.hasItems = response.totalCount > 0;
      });

    this.isPreloadTextViewed$ = this.store.pipe(select(selectCRShowInitWaitingMessage));

    this.loading$ = this.store.pipe(select(selectContactRelationshipsPageLoading));
  }
}
